/** Refunds, returns and the right of withdrawal (Ley 24.240 art. 34; Res. SCI 424/2020). */
import { CONSUMER_URL, type InfoDoc } from "../types";

export const refunds: InfoDoc = {
  es: {
    title: "Política de reembolsos",
    intro: "Cómo cancelar una compra, devolver un producto y recibir tu dinero. Si algo no quedó claro, escribinos a {email}.",
    sections: [
      {
        title: "Arrepentimiento: 10 días sin dar explicaciones",
        paragraphs: [
          "Tenés 10 días corridos desde que recibís el producto para arrepentirte de la compra, sin dar motivos (artículo 34 de la Ley 24.240).",
          "Usá el [[/arrepentimiento|botón de arrepentimiento]]: no hace falta tener cuenta. Te damos un código de trámite en el momento y te lo mandamos por email. Dentro de las 48 horas te contactamos con los pasos para la devolución.",
          "El envío de vuelta corre por nuestra cuenta. Te pedimos que nos devuelvas el producto tal como lo recibiste (revisarlo para ver que esté bien no cuenta como uso).",
          "Si no podés devolverlo así por algo que hiciste vos (por ejemplo, abriste un producto sellado o una carta se dañó mientras la tenías), igual podés arrepentirte: en ese caso nos pagás el valor de mercado que tenga el producto en ese momento, nunca más de lo que pagaste, y lo descontamos del reintegro (artículo 1114 del Código Civil y Comercial).",
        ],
      },
      {
        title: "Productos con problemas",
        paragraphs: [
          "Si recibiste algo distinto a lo publicado (otra carta, otro estado, otro idioma o terminación) o un producto dañado, avisanos lo antes posible a {email} con fotos y el número de pedido: cuanto antes nos avises, más fácil es resolverlo con el correo.",
          "Elegís si preferís el cambio por el producto correcto (si hay stock) o el reintegro total, incluido el envío (artículo 17 de la Ley 24.240).",
          "Además tenés la garantía legal por defectos: 6 meses para productos nuevos (los sellados) y 3 meses para productos usados (las cartas sueltas, que ya salieron de su sobre), desde la entrega (artículo 11 de la Ley 24.240).",
        ],
      },
      {
        title: "Pedidos cancelados antes del envío",
        paragraphs: [
          "Si cancelás un pedido pagado antes de que lo despachemos, te devolvemos el total.",
          "Si no podemos cumplir un pedido (por ejemplo, porque se vendió la última unidad en el mismo momento o por un error evidente de precio), lo cancelamos y te devolvemos el total.",
          "Los pedidos que no se pagan dentro de los 30 minutos se cancelan solos y no se cobra nada.",
        ],
      },
      {
        title: "Cómo y cuándo te devolvemos el dinero",
        paragraphs: [
          "Siempre por el mismo medio con el que pagaste: Mercado Pago, tarjeta (Stripe) o PayPal. Lo hacemos en cuanto recibimos el producto devuelto, o en el momento en que cancelamos el pedido si todavía no lo habíamos despachado.",
          "Cuánto tarda en verse depende del medio de pago: en Mercado Pago suele ser inmediato; en tarjetas de crédito puede aparecer en uno o dos resúmenes.",
          "Si pagaste en pesos, te devolvemos los mismos pesos que se te cobraron. Si pagaste en dólares, los mismos dólares.",
        ],
      },
      {
        title: "¿No quedaste conforme?",
        paragraphs: [`Si no resolvemos tu reclamo, podés acudir a Defensa de las y los Consumidores: ${CONSUMER_URL}.`],
      },
    ],
  },
  en: {
    title: "Refund policy",
    intro: "How to cancel a purchase, return a product and get your money back. If anything is unclear, write to {email}.",
    sections: [
      {
        title: "Withdrawal: 10 days, no questions asked",
        paragraphs: [
          "You have 10 calendar days from receiving the product to withdraw from the purchase without giving a reason (article 34 of Argentine Law 24,240).",
          "Use the [[/arrepentimiento|withdrawal button]]: no account needed. You get a request code right away, also by email, and we contact you within 48 hours with the return steps.",
          "We pay the return shipping. Please send the product back as you received it (checking that it's fine doesn't count as use).",
          "If you can't return it that way because of something you did (for example, you opened a sealed product or a card got damaged while you had it), you can still withdraw: you then owe us the product's market value at that moment, never more than you paid, and we deduct it from the refund (article 1114 of the Argentine Civil and Commercial Code).",
        ],
      },
      {
        title: "Products with problems",
        paragraphs: [
          "If you received something different from the listing (another card, condition, language or finish) or a damaged product, let us know as soon as possible at {email} with photos and the order number: the sooner, the easier it is to sort out with the carrier.",
          "You choose between a replacement (if in stock) or a full refund, shipping included (article 17 of Argentine Law 24,240).",
          "You also have the legal warranty against defects: 6 months for new products (sealed ones) and 3 months for used ones (single cards, already out of their pack), from delivery (article 11 of Law 24,240).",
        ],
      },
      {
        title: "Orders cancelled before shipping",
        paragraphs: [
          "If you cancel a paid order before we ship it, we refund the full amount.",
          "If we cannot fulfil an order (for example, the last unit sold at the same moment, or an obvious price error), we cancel it and refund the full amount.",
          "Orders not paid within 30 minutes are cancelled automatically and nothing is charged.",
        ],
      },
      {
        title: "How and when you get your money back",
        paragraphs: [
          "Always through the payment method you used: Mercado Pago, card (Stripe) or PayPal. We issue it as soon as we receive the returned product, or when we cancel the order if it hadn't shipped yet.",
          "How long it takes to show depends on the method: Mercado Pago is usually immediate; credit cards may take one or two statements.",
          "If you paid in pesos, you get back the same pesos you were charged; if you paid in dollars, the same dollars.",
        ],
      },
      {
        title: "Not satisfied?",
        paragraphs: [`If we don't solve your complaint, you can turn to Argentina's consumer protection office: ${CONSUMER_URL}.`],
      },
    ],
  },
};
